import styled from 'styled-components';

export const ImportContactsContainer = styled.div`
  & > div:first-child {
    margin-bottom: 24px;
  }
  div.label {
    font-weight: 600;
    font-size: 12px;
    color: #475867;
  }
  div.info-label {
    font-weight: 400;
    font-size: 12px;
    color: #475867;
    margin-bottom: 4px;
    display: block;
    align-items: baseline;
    & > div:last-child {
      margin-left: 8px;
    }
  }
  div.condition {
    font-weight: 600;
    font-size: 15px;
    color: #000000;
    margin: 8px 0;
    text-align: center;
  }

  div.info {
    line-height: 24px;
    margin-bottom: 16px;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: #1b334b;
    strong {
      font-weight: bold;
      color: var(--text-link);
    }
  }

  // upload file styles
  div.lev1 {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.408px;
    color: var(--color-elephant-900);
  }
  div.lev2 {
    font-size: 12px;
    line-height: 24px;
    letter-spacing: -0.408px;
    color: var(--color-elephant-900);
  }
  div.lev3 {
    font-size: 10px;
    line-height: 12px;
    color: #000000;
    opacity: 0.4;
  }
  div.name {
    margin-top: 8px;
    font-size: 10px;
    font-weight: bold;
  }

  & .upload-container svg {
    width: 24px;
    height: 24px;
  }
`;

export const MappingTable = styled.table`
  width: 100%;
  border-spacing: 0;
  thead {
    background: linear-gradient(0deg, #f5f7f9, #f5f7f9), #ffffff;
  }
  td {
    padding: 12px;
  }
  th {
    text-align: left;
    padding: 12px;
    font-weight: 600;
    font-size: 14px;
    text-transform: uppercase;
    color: #1b334b;
  }
  th.flex {
    display: flex;
    align-items: center;
    & > :not(:last-child) {
      margin-right: 10px;
    }
  }
  td.key {
    font-size: 14px;
    color: #1b334b;
  }
  td.center {
    text-align: center;
  }
`;

export const ContactActions = styled.div`
  display: flex;
  align-items: stretch;
  flex-wrap: nowrap;
  div.grid {
    display: grid;
    place-content: center;
    flex: 1;
    cursor: pointer;
    padding: 24px;
    background: #fcfcfc;
    border: 1px dashed #dddddd;
    box-shadow: 0px 2px 4px rgba(18, 52, 77, 0.06);
    border-radius: 8px;
    position: relative;
    input[type='file'] {
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
    :not(:last-child) {
      margin-right: 10px;
    }
  }
  div.item {
    display: flex;
    align-items: center;

    div.item-desc {
      div.lev1 {
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: -0.408px;
        color: #12344d;
      }
      div.lev2 {
        font-size: 12px;
        line-height: 24px;
        letter-spacing: -0.408px;
        color: #12344d;
      }
      div.lev3 {
        font-size: 10px;
        line-height: 12px;
        color: #000000;
        opacity: 0.4;
      }
      div.name {
        margin-top: 8px;
        font-size: 10px;
        font-weight: bold;
      }
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-left: 24px;
    }
  }
`;
export const ImportDisplayBox = styled.div`
  margin-top: 16px;
  background: #f5f5f5;
  border: 1px solid #e9e9e9;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 15px;
  display: grid;
  place-content: center;
  :not(:last-child) {
    margin-bottom: 16px;
  }
  a {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #006cc2;
  }
  a:hover {
    color: #006cc2;
  }
  /* a:link {
    color: #006cc2;
  } */
  a:link:hover {
    text-decoration: underline;
  }
`;

export const ApiImport = styled.div`
  display: flex;
  align-items: center;
  span {
    font-size: 14px;
    line-height: 17px;
    color: #000000;
    margin-right: 6px;
  }
`;

export const IntegrateBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  div.lev1 {
    font-size: 14px;
    color: #000000;
    margin-bottom: 6px;
  }
  div.lev2 {
    font-size: 14px;
    color: #000000;
    font-weight: bold;
    margin-bottom: 12px;
  }
`;

export const CustomSelect = styled.div`
  display: flex;
  align-items: center;
  overflow-wrap: anywhere;
  span.red {
    color: var(--text-danger);
    margin-left: 4px;
  }
`;
